module.exports = "/public/webpack/img/icon_help_categories_other_32c80aa54e4da3347220ba2b33e4385c67.png";